import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Menu } from '@mui/material';
import React, { useState } from 'react';

/** Row actions for the bills table: the "…" trigger with the options behind it. */
export function BillActionsMenu(_ref) {
  let _ref$canDelete = _ref.canDelete,
    canDelete = _ref$canDelete === void 0 ? true : _ref$canDelete,
    _ref$canPush = _ref.canPush,
    canPush = _ref$canPush === void 0 ? false : _ref$canPush,
    deleteDisabledHint = _ref.deleteDisabledHint,
    onDelete = _ref.onDelete,
    onPush = _ref.onPush,
    onViewDetails = _ref.onViewDetails,
    pushDisabledHint = _ref.pushDisabledHint,
    _ref$showPush = _ref.showPush,
    showPush = _ref$showPush === void 0 ? false : _ref$showPush;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClose = () => setAnchorEl(null);
  const runAndClose = action => () => {
    handleClose();
    action();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "aria-controls": open ? 'bill-actions-menu' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "true",
    "aria-label": "Bill actions",
    onClick: event => setAnchorEl(event.currentTarget),
    size: "small",
    state: open ? 'active' : undefined,
    variant: "actionIcon"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "dotdotdot"
  })), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchorEl,
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    elevation: 0,
    id: "bill-actions-menu",
    onClose: handleClose,
    open: open,
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    type: "action-menu"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: runAndClose(onViewDetails),
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "zoom-in"
  }), "View details"), showPush ? /*#__PURE__*/React.createElement("span", {
    title: pushDisabledHint || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !canPush,
    onClick: runAndClose(onPush),
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "upload"
  }), "Push to AppFolio")) : null, /*#__PURE__*/React.createElement("span", {
    title: canDelete ? undefined : deleteDisabledHint || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !canDelete,
    onClick: runAndClose(onDelete),
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }), "Delete"))));
}